import { render, staticRenderFns } from "./PaginaNaoEncontradaView.vue?vue&type=template&id=02e850a0&scoped=true"
import script from "./PaginaNaoEncontradaView.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginaNaoEncontradaView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PaginaNaoEncontradaView.vue?vue&type=style&index=0&id=02e850a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e850a0",
  null
  
)

export default component.exports